import React, { forwardRef, CSSProperties } from 'react';
import { COLORS } from '../utils/colors';
import useImage from '../utils/useImage';

interface SpecialItemProps {
  imageName: string;
  isDragging?: boolean;
  withOpacity?: boolean;
  style?: CSSProperties;
  disabled: boolean;
}

const SpecialItem = forwardRef<HTMLDivElement, SpecialItemProps>(
  ({ isDragging, style, imageName, disabled, ...props }, ref) => {
    const borderRadius = 8;
    const mobileProportions = window.outerWidth < window.outerHeight * 0.75;
    const width = Math.min(
      mobileProportions
        ? window.outerWidth * 0.3
        : window.outerHeight * 0.19,
      250
    );
    const ratio = 0.95
    const renderWidth = disabled ? width * ratio : width
    const inlineStyles: CSSProperties = {
      height: width,
      width: width,
      backgroundColor: disabled ? COLORS.GREEN : undefined,
      borderRadius,
      cursor: isDragging ? 'grabbing' : 'grab',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxShadow: isDragging
        ? 'rgb(63 63 68 / 5%) 0px 2px 0px 2px, rgb(34 33 81 / 15%) 0px 2px 3px 2px'
        : 'rgb(63 63 68 / 5%) 0px 0px 0px 1px, rgb(34 33 81 / 15%) 0px 1px 3px 0px',
      transform: isDragging ? 'scale(1.1)' : 'scale(1)',
      ...style,
    };

    const { image } = useImage(imageName);

    return (
      <div ref={ref} style={inlineStyles} {...props} className='grid-item'>
        {image && (
          <img 
            src={image} 
            width={renderWidth} 
            height={renderWidth} 
            style={{borderRadius}} 
            data-image-name={imageName}
            alt={imageName}
          />
        )}
      </div>
    );
  }
);

export default SpecialItem;
